import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";
import { MascotaDesertora } from "../../../services/analisisOperaciones";
import Pagination from "../../organisms/Pagination";
import { formatearFechaStr } from "../../../utils/dateUtils";
import { generatePage } from "../../../utils/tableUtils";

interface MascotasDesertorasTableProps {
  mascotasDesertoras: MascotaDesertora[];
  isLoading: boolean;
  itemsPorPagina: number;
}

function MascotasDesertorasTable({
  mascotasDesertoras,
  isLoading,
  itemsPorPagina,
}: MascotasDesertorasTableProps) {
  const [activePageNumber, setActivePageNumber] = useState(1);

  const paginaActual = useMemo(
    () =>
      generatePage(
        mascotasDesertoras,
        activePageNumber,
        itemsPorPagina
      ) as MascotaDesertora[],
    [mascotasDesertoras, activePageNumber, itemsPorPagina]
  );
  const totalMascotasDesertoras = mascotasDesertoras.length;

  return (
    <>
      <Table responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Mascota</StyledColHeader>
            <StyledColHeader>Propietario</StyledColHeader>
            <StyledColHeader>Fecha último plan</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {paginaActual.map((item) => (
            <tr key={item.idMascota}>
              <td>{item.nombreMascota}</td>
              <td>{item.propietario}</td>
              <td>{formatearFechaStr(item.fechaUltimoPlan)}</td>
            </tr>
          ))}
          {totalMascotasDesertoras > 0 && (
            <StyledSummaryRow>
              <td colSpan={2}>Total</td>
              <td>{totalMascotasDesertoras}</td>
            </StyledSummaryRow>
          )}
          {!isLoading && paginaActual.length === 0 && (
            <tr>
              <td colSpan={3}>
                No hay mascotas desertoras actualmente.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        pageSize={itemsPorPagina}
        setActivePageNumber={setActivePageNumber}
        activePageNumber={activePageNumber}
        rows={mascotasDesertoras}
      />
    </>
  );
}

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledSummaryRow = styled("tr")`
  background-color: ${(props) => props.theme.colors.light};
  font-weight: 700;
`;

export default MascotasDesertorasTable;
